const { AllSocialMedia } = require("../features/admin/common/Slice");

exports.APIS = {
  Auth: "/common/auth/admin-login",
  UserGet: "/common/auth/user-info",
  ChangePassword: "/common/auth/change-password",

  Masters: {
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    Pincode: "/admin/masters/pincode",
    Privacy_and_Policy: "/admin/masters/privacyandpolicy",
    Terms_and_Conditions: "/admin/masters/termsandconditions",
    Blog: "/admin/masters/blog",
    Final_Thought: "/admin/masters/finalthoughts",
    Banner: "/admin/masters/banners",
    Property_Type: "/admin/masters/property-type",
    Sub_Property: "/admin/masters/sub-property",
    Furnishing_Type: "/admin/masters/furnishing-type",
    Parking_Space: "/admin/masters/parking-space",
    BHK: "/admin/masters/bhk",
    Floor_Preference: "/admin/masters/floor-preference",
    Legal_Question: "/admin/masters/question",
    Step_Feature: "/admin/masters/stepfeature",
    Security: "/admin/masters/security",
    Restriction: "/admin/masters/restriction",
    Sale_Type: "/admin/masters/sale-type",
    Amenity: "/admin/masters/amenity",
    Property: "/admin/masters/property",
    App_Setup: "/admin/masters/app-setup",
    Subject: "/admin/masters/subject",
    Review: "/admin/masters/review",
    Project: "/admin/masters/project",
    Purpose_Of_Appointment: "/admin/masters/purposeofappointment",
    Risk_Assessment: "/admin/masters/risk-assessment",
    PropertyMaking: "/admin/masters/propertymakingstatus",
    AddStep1: "/admin/masters/property/step1",
    AddStep2: "/admin/masters/property/step2",
    AddStep3: "/admin/masters/property/step3",
    AddStep4: "/admin/masters/property/step4",
    AddStep5: "/admin/masters/property/step5",
    AddStep6: "/admin/masters/property/step6",
    AddStep7: "/admin/masters/property/step7",
    getStepsDetails: "/admin/masters/property/steps",
    findAllWithSteps: "/admin/masters/property/findallstepspagination",
    findAllDeletedProperty: "/admin/masters/property/findalldeletedproperty",
    DeleteFlatVideo: "/admin/masters/property/deletevideo",
    DeleteSingleImage: "/admin/masters/property/deletesingleimage",
  },

  // common
  Commons: {
    AllCountry: "/common/masters/all-country",
    AllState: "/common/masters/all-state",
    AllCity: "/common/masters/all-city",
    AllPincode: "/common/masters/all-pincode",
    AllProperty: "/common/masters/all-propertytype",
    AllSubProperty: "/common/masters/all-sub-property",
    AllProperties: "/common/masters/all-property",
    AllQuestion: "/common/masters/all-question",
    AllPermmission: "/common/masters/all-permission",
    AllRoles: "/common/masters/all-roles",
    AllSaleType: "/common/masters/all-sale-type",
    AllBhk: "/common/masters/all-bhk",
    AllFloorPreference: "/common/masters/all-floor-preference",
    AllFurnishingType: "/common/masters/all-furnishing",
    AllAmenity: "/common/masters/all-amenity",
    AllParkingSpace: "/common/masters/all-parkingspace",
    AllSecurity: "/common/masters/all-security",
    AllStepFeature: "/common/masters/all-step-feature",
    AllRestriction: "/common/masters/all-restriction",
    AllSubscriptionFeature: "/common/masters/all-subscription-feature",
    AllTicketRaised: "/common/masters/all-ticket-raised",
    AllProperty_Status: "/common/masters/all-property-status",
    AllProject: "/common/masters/all-project",
    AllUser: "/common/masters/all-user",
    AllBuilder: "/common/masters/all-builder",
    AllBannerType: "/common/masters/all-banner-type",
    GetBhksByProject: "/common/masters/bhks-by-project",
    // AllAssignedCustomer: "/common/masters/assigned-customers",
    AllSalesPerson: "/common/masters/all-sales-person",
    AllNotificationUser: "/common/masters/all-notification-user",
    AllTrackingAssign: "/common/masters/all-tracking-assign-user",
    AllTermsType: "/common/masters/all-term-type",
    AllTermsCondition: "/common/masters/all-term-condition-builder",
    AllPropertyMakingStatus: "/common/masters/property-making-status",
    AllAmenities: "/common/masters/amenity",
    AllCoupnType: "/common/masters/coupn-type",
    AllKycStatus: "/common/masters/all-kyc-status",
  },

  // Dashboard
  Dashboard: {
    dashboard: "/admin/dashboard",
  },

  UserManagement: {
    Roles: "/admin/employee-management/role",
    Builder: "/admin/employee-management/builder",
    Users: "/admin/employee-management/user",
    Sales: "/admin/employee-management/sales",
  },

  LegalRisk: {
    User_Question: "/admin/legal-risk/user-question-answer",
    Legal_Advisor_Appointment: "/admin/legal-risk/legal-advisor-booking",
  },

  ShortlistedProperty: {
    Property_Document: "/admin/shortlisted-property/user-shortlisted-property",
    Resell_Property: "/admin/shortlisted-property/user-resell-property",
    Legal_Verification: "/admin/shortlisted-property/legal-verification",
  },

  BankNsfc: {
    User_Information: "/admin/bank-nsfc/user-bank-nsfc",
  },

  ExploreProperty: {
    Appointment_Booking: "/admin/explore-property/user-explore-property",
    Appointment_Booking_History:
      "/admin/explore-property/user-explore-property-reschedule",
  },

  BestProperty: {
    Best_Price_Property: "/admin/best-price/user-best-property",
  },

  PropertyInspection: {
    Reinspection: "/admin/property-inspection/user-property-inspection",
    Inspection_Appointment: "/admin/property-inspection/user-inspection-form",
  },

  TicketRaised: {
    Ticket: "/admin/ticket-raised/user-ticket-raised",
  },

  PushNotification: {
    User_Notification: "/admin/notification",
  },

  InquiryForm: {
    Inquiry: "/admin/inquiry",
  },

  ContactForm: {
    Contact_Us: "/admin/contact-us",
  },

  ReviewForm: {
    User_Rating: "/admin/user-ratings",
  },

  ActivityTracker: {
    User_Activity: "/admin/activity-tracker",
  },

  Wallet: {
    Wallet_History: "/admin/wallet-history",
  },

  UserKyc: {
    Kyc: "/admin/kyc",
  },

  CouponManagement: {
    Coupon: "/admin/coupon-management/coupon",
    Subscription: "/admin/coupon-management/subscription",
    User_Subscription: "/admin/coupon-management/subscription-history",
  },
};
